import React from 'react';
import TopBarEvent from '../../../../elements/TopBar/TopBarEvent';
import LeadsTabs from '../LeadsTabs';
import DownloadButton from './DownloadButton';
import styles from './LeadsHeader.module.scss';

function LeadsHeader(props) {
    const { event, tab } = props;

    return (
        <>
            <TopBarEvent event={event} leads returnURL="../.." />
            <div className={['d-flex', 'flex-row', styles.tabs].join(' ')}>
                <LeadsTabs className="flex-grow-1" tab={tab} />
                <DownloadButton className={['flex-grow-0', styles.button].join(' ')} eventId={event.id} />
            </div>
        </>
    );
}

export default LeadsHeader;
